import { connect } from 'react-redux';
import { createLoadingSelector } from 'redux/selectors';
import { remainPartner } from 'redux/services/api/unregister';
import UnregisterRemain from './unregister-remain';

const loadingSelector = createLoadingSelector(['UNREGISTER_REMAIN']);

const mapStateToProps = (state) => ({
  success: state.api.unregister.remainSuccess,
  error: state.api.unregister.remainError,
  loading: loadingSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  remainPartner: (personId) => dispatch(remainPartner(personId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnregisterRemain);